import * as z from 'zod';
import { SCRIPT_SCHEMA } from '../scripting';
export class SSE {
    context;
    options;
    static get manifest() {
        return {
            name: 'sse',
            schema: z.object({
                operation: z.string(),
                listener: SCRIPT_SCHEMA()
            })
        };
    }
    constructor(context, args) {
        this.context = context;
        this.options = args;
    }
    destroy() {
    }
}
//# sourceMappingURL=sse.js.map